import classNames from "classnames"
import React from "react"

import getColumnClasses from "./getColumnClasses"
import getGapClasses from "./getGapClasses"

import { Columns, Gap } from "./types"

export interface GridProps {
  as?: "div" | "section"
  children: React.ReactNode
  columns: Columns
  gap?: Gap
}

export const Grid = ({ as = "div", children, columns, gap = 1 }: GridProps) => {
  const GridHtmlElement = as
  return (
    <GridHtmlElement
      data-testid="grid"
      className={classNames(
        "grid",
        getColumnClasses(columns),
        gap && getGapClasses(gap),
      )}
    >
      {children}
    </GridHtmlElement>
  )
}
